module.exports = __webpack_public_path__ + "img/biaoz.12a948df.jpg";